const BASE_URL = "https://www.r-info.tohoku.ac.jp";
//const BASE_URL = "https://d36wdtkz20fgfe.cloudfront.net";

export default Object.freeze({
    BASE_URL: BASE_URL,
    ORGANIZATIONS_URL: BASE_URL.concat("/master/organizations.json"),
    RESEARCH_AREAS_URL: BASE_URL.concat("/master/research_areas.json"),
    SEARCH_API: BASE_URL.concat("/api/query?")
});